jQuery(function ($) {
    'use strict';
    var $moreVideosGroup = $('.more-videos__item-group');
    if($moreVideosGroup.length && $moreVideosGroup.hasClass('desktop')) {
      $moreVideosGroup.slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                useCSS: false,
                mobileFirst: true,
                centerMode: true,
                prevArrow: $(".more-videos__left"),
                nextArrow: $(".more-videos__right"),
                respondTo: 'window',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2.4,
                            centerMode: false
                        }
                    },
                    {
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 2,
                            centerMode: false
                        }
                    },
                    {
                        breakpoint: 736,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
          });
    }    
});
